// Internal Imports (Models & Services)
import { PolicyBilling } from '@/api/models/Contracts';
import { ContractDetailService } from '@/api/services/contractDetailService';

// External Imports (Redux & Redux-Saga)
import { takeLatest, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

// Redux Slice Actions
import {
  fetchPolicyBillingStart,
  fetchPolicyBillingSuccess,
  fetchPolicyBillinFailure,
} from './policySlice';
import { PolicyBillingRequest } from '@/api/models/BaseRequest';
import { PayloadAction } from '@reduxjs/toolkit';

/**
 * Saga function to fetch equipment data.
 * It makes an API call and dispatches either a success or failure action.
 */
function* fetchPolicyBillingSaga(
  action: PayloadAction<{ policyId: string, clientId: string }>,
): Generator<CallEffect<PolicyBilling[]> | PutEffect, void, PolicyBilling[]> {
  try {
    const request: PolicyBillingRequest = {
      policyId: action.payload.policyId,
      clientId : action.payload.clientId,
    };

    const policyBilling: PolicyBilling[] = yield call(
      ContractDetailService.fetchPolicyBilling,
      request,
    );

    yield put(fetchPolicyBillingSuccess(policyBilling));
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Fetching equipments failed';
    yield put(fetchPolicyBillinFailure(errorMessage));
  }
}

/**
 * Watcher Saga that listens for `fetchEquipmentRequest` actions
 * and triggers `fetchEquipmentSaga` when the action is dispatched.
 */
export function* watchPolicyBilling(): SagaIterator {
  yield takeLatest(fetchPolicyBillingStart.type, fetchPolicyBillingSaga);
}
